import { useCallback } from "react";
import { useDebounce } from "react-use";
import { getNotifications } from "@/controllers/notifications";

export function useNotificationsFetcher(asPath: string, stockTradingItemId: any, setNotificationsList: (list: any) => void) {
    const extractPath = useCallback(() => {
        if (asPath.includes("/s/")) {
            return asPath.split("/")[4];
        } else {
            return asPath.split("/")[1].split("?")[0];
        }
    }, [asPath]);

    const extractStock = useCallback(() => {
        if (asPath.includes("/s/")) {
            return stockTradingItemId;
        } else {
            return null;
        }
    }, [asPath, stockTradingItemId]);

    const checkNotifications = useCallback(async () => {
        const page = asPath ? extractPath() : null;
        const stock = asPath ? extractStock() : null;

        getNotifications(page, stock)
            .then((res) => {
                // A signed-out visitor is answered 403 and there is no `results`; storing that
                // `undefined` as the list crashed the header bell (#1286). Only ever store an array.
                setNotificationsList(Array.isArray(res?.results) ? res.results : []);
            })
            .catch(() => {
                // A failed refresh keeps whatever is already shown; the next route change retries.
            });
    }, [asPath, extractPath, extractStock, setNotificationsList]);

    useDebounce(
        () => {
            checkNotifications();
        },
        500,
        [asPath, stockTradingItemId]
    );
}
